import { pciRouteMapByURL } from '@shared/constants/routes.pci'
import { usePathname } from 'next/navigation'

export const useIsCurrentRoutePCI = () => {
  const pathname = usePathname()
  return pciRouteMapByURL.has(pathname ?? '')
}
